import React, { memo } from "react";
import { Image, Spinner } from "react-bootstrap";
import { AnimatePresence, motion, easeInOut } from "framer-motion";

import { walletIcon } from "utils/helper";
import { useRootContext } from "context/app-context";
import { useWalletConnect } from "context/wallet-connection-context";

import "./WalletAsidebar.scss";

const WalletAsideBar = () => {
  const { walletSidebarOpen, handleToggleWalletSidebar } = useRootContext();
  const { walletList, loading, pendingConnector, handleConnectWallet } =
    useWalletConnect();

  return (
    <AnimatePresence>
      {walletSidebarOpen && (
        <motion.div
          initial={{ x: "100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "100%", opacity: 0 }}
          transition={{ duration: 0.3, ease: easeInOut }}
          className="connect-offcanvas"
        >
          <div className="offsetWrapper">
            <div className="asideImgbg">
              <img
                src={process.env.REACT_APP_S3_IMAGE_PATH + "asideBg.png"}
                alt=""
                className="img-fluid"
              />
            </div>
            <button
              className="close"
              onClick={() => handleToggleWalletSidebar()}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.342857 15.6571C0.571429 15.8857 0.8 16 1.14286 16C1.48571 16 1.71429 15.8857 1.94286 15.6571L8 9.6L14.0571 15.6571C14.2857 15.8857 14.6286 16 14.8571 16C15.0857 16 15.4286 15.8857 15.6571 15.6571C16.1143 15.2 16.1143 14.5143 15.6571 14.0571L9.6 8L15.6571 1.94286C16.1143 1.48571 16.1143 0.8 15.6571 0.342857C15.2 -0.114286 14.5143 -0.114286 14.0571 0.342857L8 6.4L1.94286 0.342857C1.48571 -0.114286 0.8 -0.114286 0.342857 0.342857C-0.114286 0.8 -0.114286 1.48571 0.342857 1.94286L6.4 8L0.342857 14.0571C-0.114286 14.5143 -0.114286 15.2 0.342857 15.6571Z"
                  fill="#FFF"
                ></path>
              </svg>
            </button>

            <div className="content">
              <div className="text-holder">
                <h3>Connect Your Wallet</h3>
                <p>
                  If you don’t have a wallet yet, you can select a provider and
                  create one now.
                </p>
              </div>

              <ul className="d-flex">
                {walletList?.map((wallet) => (
                  <li key={wallet.id}>
                    <button
                      className="custom-btn lg dim-border w-100"
                      onClick={() => handleConnectWallet(wallet)}
                      disabled={loading}
                    >
                      <Image src={walletIcon[wallet.id]} alt={wallet.id} />
                      <span className="txt">
                        {loading && wallet.id === pendingConnector.id ? (
                          <div className="spinner">
                            <Spinner
                              animation="border"
                              role="status"
                              style={{ width: "1.5rem", height: "1.5rem" }}
                              variant="secondary"
                            />
                          </div>
                        ) : (
                          `Continue with ${wallet.name}`
                        )}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default memo(WalletAsideBar);
